import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TextField,
  Typography,
  FormHelperText,
  Button
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";

import {
  getDifferentiatedValues,
  getUser,
  getUserIndex,
  isOnlyAndMainEmployee
} from "../../../../utils/HealthDeclarationForm.utils";

import { OtherMedicalConditionClass } from "../../../../model/OtherMedicalCondition.class";

import { selectHealthDeclarationOfUsers } from "../../../../redux/health-declaration/hdf.selectors";
import { handleUpdateHealthDeclaration } from "../../../../redux/health-declaration/hdf.actions";

import { questionnairesStyles, saveButton } from "../questionnaire.styles";

import { DatePickerComponent } from "../../date-picker/DatePicker.component";

export const EyeHearingSpeechQuestionnaire = props => {
  const {
    container,
    username,
    tableCell,
    infoGrid,
    textFieldRed
  } = questionnairesStyles();
  const { id } = props;
  const { userId, key, subKey } = getDifferentiatedValues(id);

  const healthDeclarationOfUsers = useSelector(selectHealthDeclarationOfUsers);
  const dispatch = useDispatch();

  const userIndex = getUserIndex(healthDeclarationOfUsers, userId);
  const user = getUser(healthDeclarationOfUsers, userId);

  const [userEyeHearingSpeech, setUserEyeHearingSpeech] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    user?.otherMedicalConditions?.eyeHearingSpeech &&
      setUserEyeHearingSpeech(user.otherMedicalConditions.eyeHearingSpeech);

    let validateSuccess = validateEyeHearingSpeech();
    let medicalCondition = user?.otherMedicalConditions?.eyeHearingSpeech;

    if (!medicalCondition || medicalCondition.length == 0) {
      setError(true);
      handleAddEyeHearingSpeech([]);
      validateSuccess = false;
    } else {
      setError(false);
      setUserEyeHearingSpeech(medicalCondition);
      validateSuccess = true;
    }

    props.handleRequiredFieldsError(key, subKey, !validateSuccess);
  }, []);

  useEffect(() => {
    if (userEyeHearingSpeech.length > 0) {
      updateUserHealthDeclaration();
    }
  }, [userEyeHearingSpeech.length]);

  const handleAddEyeHearingSpeech = () => {
    setUserEyeHearingSpeech([
      ...userEyeHearingSpeech,
      {
        nameOfCondition: "",
        nameOfConditionError: false,
        startDate: "",
        startDateError: false,
        endDate: "",
        endDateError: false,
        testTypeAndResult: "",
        testTypeAndResultError: false,
        treatmentType: "",
        treatmentTypeError: false,
        nameAddressOfDoctorConsulted: "",
        nameAddressOfDoctorConsultedError: false
      }
    ]);
  };

  const handleUpdateField = (field, index, value) => {
    userEyeHearingSpeech[index][field] = value;
    setUserEyeHearingSpeech([...userEyeHearingSpeech]);
  };

  const handleUpdateDate = (field, index, event) => {
    userEyeHearingSpeech[index][field] = event;
    setUserEyeHearingSpeech([...userEyeHearingSpeech]);
  };

  const validateEyeHearingSpeech = () => {
    let validateSuccess = true;
    let errorDisplay = "";

    if (userEyeHearingSpeech.length == 0) {
      setError(true);
      props.handleRequiredFieldsError(key, subKey, true);
      errorDisplay = "Please enter at least 1 medical condition";
    }

    //mark field error
    userEyeHearingSpeech.map(userEyeHearingSpeech => {
      userEyeHearingSpeech.nameOfConditionError = false;
      userEyeHearingSpeech.startDateError = false;
      userEyeHearingSpeech.endDateError = false;
      userEyeHearingSpeech.testTypeAndResultError = false;
      userEyeHearingSpeech.treatmentTypeError = false;
      userEyeHearingSpeech.nameAddressOfDoctorConsultedError = false;

      if (!userEyeHearingSpeech.nameOfCondition) {
        userEyeHearingSpeech.nameOfConditionError = true;
      }

      if (!userEyeHearingSpeech.startDate) {
        userEyeHearingSpeech.startDateError = true;
      }

      if (!userEyeHearingSpeech.endDate) {
        userEyeHearingSpeech.endDateError = true;
      }

      if (!userEyeHearingSpeech.testTypeAndResult) {
        userEyeHearingSpeech.testTypeAndResultError = true;
      }

      if (!userEyeHearingSpeech.treatmentType) {
        userEyeHearingSpeech.treatmentTypeError = true;
      }

      if (!userEyeHearingSpeech.nameAddressOfDoctorConsulted) {
        userEyeHearingSpeech.nameAddressOfDoctorConsultedError = true;
      }
    });

    let errorObject = userEyeHearingSpeech.find(userEyeHearingSpeech => {
      return (
        userEyeHearingSpeech.nameOfConditionError ||
        userEyeHearingSpeech.startDateError ||
        userEyeHearingSpeech.endDateError ||
        userEyeHearingSpeech.testTypeAndResultError ||
        userEyeHearingSpeech.treatmentTypeError ||
        userEyeHearingSpeech.nameAddressOfDoctorConsultedError
      );
    });

    if (errorDisplay || errorObject) {
      validateSuccess = false;
      setUserEyeHearingSpeech([...userEyeHearingSpeech]);
    }
    setError(errorDisplay);

    return validateSuccess;
  };

  const updateUserHealthDeclaration = () => {
    let validateSuccess = validateEyeHearingSpeech();
    props.handleRequiredFieldsError(key, subKey, !validateSuccess);

    if (validateSuccess) {
      props.handleRequiredFieldsError(key, subKey, false);

      let eyeHearingSpeech = [];
      let eyeHearingSpeechObject = {};

      userEyeHearingSpeech.map(userEyeHearingSpeech => {
        const medicalCondition = new OtherMedicalConditionClass(
          userEyeHearingSpeech.nameOfCondition,
          userEyeHearingSpeech.startDate,
          userEyeHearingSpeech.endDate,
          userEyeHearingSpeech.testTypeAndResult,
          userEyeHearingSpeech.treatmentType,
          userEyeHearingSpeech.nameAddressOfDoctorConsulted
        );
        eyeHearingSpeechObject = medicalCondition.getOtherMedicalConditionDetails();
        eyeHearingSpeech.push(eyeHearingSpeechObject);
      });

      const updatedUser = {
        ...user,
        [key]: { ...user[key], eyeHearingSpeech }
      };

      healthDeclarationOfUsers[userIndex] = updatedUser;
      dispatch(handleUpdateHealthDeclaration(healthDeclarationOfUsers));
    }
  };

  const handleRemove = index => {
    userEyeHearingSpeech.splice(index, 1);
    setUserEyeHearingSpeech([...userEyeHearingSpeech]);

    validateEyeHearingSpeech();
  };

  return (
    <Box className={container}>
      <Typography className={username}>
        {isOnlyAndMainEmployee(healthDeclarationOfUsers) ? "" : user?.full_name}
        {isOnlyAndMainEmployee(healthDeclarationOfUsers)
          ? ""
          : user.person_type === "EMPLOYEE"
          ? "(Self)"
          : user.person_type === "SPOUSE"
          ? "(Spouse)"
          : "(Child)"}
      </Typography>

      {userEyeHearingSpeech.map((eyeHearingSpeech, index) => {
        return (
          <Table key={index}>
            <TableRow>
              <TableCell colSpan={3} align="left">
                <Grid container item spacing={2} flexDirection={"column"}>
                  <Grid item xs={5} className={infoGrid}>
                    <Box fontWeight="bold">Medical Condition {index + 1}</Box>
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell align="center">
                <Button onClick={e => handleRemove(index)}>
                  <FormHelperText
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "1em",
                      textTransform: "none"
                    }}
                  >
                    Remove
                  </FormHelperText>
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={tableCell}>
                <Grid container item spacing={2} flexDirection={"column"}>
                  <Grid item xs={5} className={infoGrid}>
                    <Box fontWeight="bold">Name of Condition</Box>
                  </Grid>
                  <Grid item xs={7} className={infoGrid}>
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      className={textFieldRed}
                      required
                      error={eyeHearingSpeech.nameOfConditionError}
                      helperText={
                        eyeHearingSpeech.nameOfConditionError &&
                        "This field is mandatory."
                      }
                      onChange={event => {
                        handleUpdateField(
                          "nameOfCondition",
                          index,
                          event.target.value
                        );
                      }}
                      value={eyeHearingSpeech.nameOfCondition}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell className={tableCell}>
                <Grid container item spacing={2} flexDirection={"column"}>
                  <Grid item xs={5} className={infoGrid}>
                    <Box fontWeight="bold">Start Date</Box>
                  </Grid>
                  <Grid item xs={7} className={infoGrid}>
                    <DatePickerComponent
                      key={eyeHearingSpeech.startDate}
                      date={eyeHearingSpeech.startDate}
                      onDateChange={event => {
                        handleUpdateDate("startDate", index, event);
                      }}
                    />
                    {eyeHearingSpeech.startDateError && (
                      <FormHelperText style={{ color: "red" }}>
                        This field is mandatory.
                      </FormHelperText>
                    )}
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell className={tableCell}>
                <Grid container item spacing={2} flexDirection={"column"}>
                  <Grid item xs={5} className={infoGrid}>
                    <Box fontWeight="bold">End Date</Box>
                  </Grid>
                  <Grid item xs={7} className={infoGrid}>
                    <DatePickerComponent
                      key={eyeHearingSpeech.endDate}
                      date={eyeHearingSpeech.endDate}
                      onDateChange={event => {
                        handleUpdateDate("endDate", index, event);
                      }}
                    />
                    {eyeHearingSpeech.endDateError && (
                      <FormHelperText style={{ color: "red" }}>
                        This field is mandatory.
                      </FormHelperText>
                    )}
                  </Grid>
                </Grid>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={tableCell}>
                <Grid container item spacing={2} flexDirection={"column"}>
                  <Grid item xs={5} className={infoGrid}>
                    <Box fontWeight="bold">Type of test(s) done and result</Box>
                  </Grid>
                  <Grid item xs={7} className={infoGrid}>
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      className={textFieldRed}
                      required
                      error={eyeHearingSpeech.testTypeAndResultError}
                      helperText={
                        eyeHearingSpeech.testTypeAndResultError &&
                        "This field is mandatory."
                      }
                      onChange={event => {
                        handleUpdateField(
                          "testTypeAndResult",
                          index,
                          event.target.value
                        );
                      }}
                      value={eyeHearingSpeech.testTypeAndResult}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell className={tableCell}>
                <Grid container item spacing={2} flexDirection={"column"}>
                  <Grid item xs={5} className={infoGrid}>
                    <Box fontWeight="bold">Type of Treatment</Box>
                  </Grid>
                  <Grid item xs={7} className={infoGrid}>
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      className={textFieldRed}
                      required
                      error={eyeHearingSpeech.treatmentTypeError}
                      helperText={
                        eyeHearingSpeech.treatmentTypeError &&
                        "This field is mandatory."
                      }
                      onChange={event => {
                        handleUpdateField(
                          "treatmentType",
                          index,
                          event.target.value
                        );
                      }}
                      value={eyeHearingSpeech.treatmentType}
                    />
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell className={tableCell}>
                <Grid container item spacing={2} flexDirection={"column"}>
                  <Grid item xs={5} className={infoGrid}>
                    <Box fontWeight="bold">
                      Name & Address of Doctors/ Clinics/ Hospitals
                    </Box>
                  </Grid>
                  <Grid item xs={7} className={infoGrid}>
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      className={textFieldRed}
                      required
                      error={eyeHearingSpeech.nameAddressOfDoctorConsultedError}
                      helperText={
                        eyeHearingSpeech.nameAddressOfDoctorConsultedError &&
                        "This field is mandatory."
                      }
                      onChange={event => {
                        handleUpdateField(
                          "nameAddressOfDoctorConsulted",
                          index,
                          event.target.value
                        );
                      }}
                      value={eyeHearingSpeech.nameAddressOfDoctorConsulted}
                    />
                  </Grid>
                </Grid>
              </TableCell>
            </TableRow>
          </Table>
        );
      })}

      <Button
        // className={addPrivateFlying}
        endIcon={<AddIcon style={{ color: "red" }} />}
        onClick={handleAddEyeHearingSpeech}
      >
        <FormHelperText
          style={{
            color: "red",
            fontWeight: "bold",
            fontSize: "1em",
            textTransform: "none"
          }}
        >
          Add Medical Condition
        </FormHelperText>
      </Button>

      <br />
      <br />
      <FormHelperText style={{ color: "red" }}>{error}</FormHelperText>

      <TableRow>
        <br />
        <Grid item xs={5} className={infoGrid}>
          <Box fontWeight="bold">
            Please upload a copy of Medical Report if it is available.
          </Box>
        </Grid>
      </TableRow>

      <br />
      <Button
        variant="outlined"
        sx={{ ...saveButton }}
        onClick={updateUserHealthDeclaration}
      >
        Save
      </Button>
    </Box>
  );
};
